package org.moxultimate.topwithmox.components.texts

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.functions.clamp
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.vw
import org.moxultimate.topwithmox.theme.*

@Composable
fun DetailsText(
    title: String,
    details: String,
    color: Color = WhiteTextColor,
    titleFontWeight: FontWeight = FontWeight.Bold,
    modifier: Modifier = Modifier,
) {
    Column(modifier) {
        SpanText(
            text = title,
            modifier = modifier
                .color(color)
                .fontFamily(FontFamily)
                .fontSize(clamp(
                    min = MinDetailFontSize,
                    value = 1.vw,
                    max = MaxDetailFontSize)
                )
                .fontWeight(titleFontWeight)
        )

        SpanText(
            text = details,
            modifier = modifier
                .color(color)
                .fontFamily(FontFamily)
                .fontSize(clamp(min = MinDetailTypeFontSize, value = 0.8.vw, max = MaxDetailTypeFontSize))
                .fontWeight(FontWeight.Thin)
        )
    }

}